import { render, staticRenderFns } from "./STableProductPurchaseComp.vue?vue&type=template&id=a08d25dc&"
import script from "./STableProductPurchaseComp.vue?vue&type=script&lang=js&"
export * from "./STableProductPurchaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports